export default __webpack_public_path__ + "static/media/926.8eb4d0e2.gif";